import { booleanResultResolver } from '@clutter/abeet';

import { useGeocodeQuery } from '@graphql/platform';

import { useAbeetVisitorTest } from '@shared/abeet';

export function useItemPlanTest(zip?: string) {
  const { data } = useGeocodeQuery({
    variables: { zip: zip! },
    skip: !zip,
  });

  const region = data?.geocode?.region;

  const eligible =
    region && (region.name === 'San Francisco' || region.name === 'New Jersey');

  const result = useAbeetVisitorTest('web_visitor_item_plan', {
    resolver: booleanResultResolver('enabled'),
    skip: !eligible,
  })[0];

  return result ?? false;
}
